export default class MongoPaypal {
  userId = "";
  email = "";

  default = false;
}
